<template>
  <div class="container">

    <v-card>
      <v-card-title class="blue accent-1 gray--text">Subir Inventario de patio</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="green"
                  dark
                  right
                 @click="upload = !upload"
                  v-on="on"
                >
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Subir excel de inventario</span>
            </v-tooltip>
          </v-col>
          <v-col cols="4">
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Escriba para filtrar bins"
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table 
        :headers="binsListHeaders"
        :items="binsListBody"
        class="elevation-3 mt-5"
        no-data-text="No hay bins"
        :search="search"
    >
    </v-data-table>

    <!-- Modal upload -->
    <v-dialog
      v-model="upload"
      width="600px"
    >
      <v-card>
        <v-card-title class="green darken-1">
          Subir inventario de bins
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-file-input v-model="file" accept=".xls, .xlsx" label="Archivo Excel"></v-file-input>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            @click="upload = false"
          >Cerrar</v-btn>
          <v-btn
            color="primary"
            @click="uploadInventario"
          >Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal -->

    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="color"
    >
      {{ validation_message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      errors: [],
      snackbar: false,
      color: 'green',
      validation_message: '',
      search: null,
      file: null,
      dialog: false,
      upload: false,
      changeState: false,
      companies: [],
      colors: [],
      sizes: [],
      state: null,
      states: [],
      binIndex: -1,
      bin: {
        id: 0,
        code: '',
        number: '',
        color: null,
        size: null,
        company: null,
        waybill: '',
        purchase_date: new Date().toISOString().substr(0, 10),
      },
      binsListHeaders: [
        {
          text: 'Numero',
          align: 'center',
          sortable: true,
          value: 'bin.number',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Color',
          align: 'center',
          sortable: true,
          value: 'bin.color.name',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Tamaño',
          align: 'center',
          sortable: true,
          value: 'bin.size.name',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Codigo',
          align: 'center',
          sortable: true,
          value: 'bin.code',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Fecha Inventario',
          align: 'center',
          sortable: true,
          value: 'movement_date',
          class: "salmon black--text elevation-3"
        },
      ],
      binsListBody: [],
    }),
    mounted() {
      this.loadInventario();
    },
    methods:{
      async loadInventario(){
        this.mostrarLoading('Cargando listado de bins...');
        let url = `${this.base_url}bins/inventario/patio`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.binsListBody = response.data.data;
            this.ocultarLoading();
        }).catch((error)=>{
            console.log(error);
            this.ocultarLoading();
        });
      },
      async uploadInventario(){
        if(!this.file){
          this.validation_message = "Debe subir un archivo Excel";
          this.showSnackBar(true);
          return;
        }
        this.headers.headers['Content-Type'] = "multipart/form-data";
        let url = `${this.base_url}bins/upload/inventario`;
        let formData = new FormData();
        formData.append("excel", this.file);
        await this.axios.post(url, formData, this.headers).then((response)=>{
          console.log(response.data.data);
          this.file = null;
          this.upload = false;
          this.loadInventario();
          this.showSnackBar(false);
        }).catch((response)=>{
          console.log(response);
          this.validation_message = "Formato de archivo no válido";
          this.showSnackBar(true);
        });
      },
      showSnackBar(error){
        if(error){
          this.color = 'red';
        }else{
          this.color = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
      ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'headers']),
      setCode: function(){
        let company = this.bin.company == null ? '': this.bin.company.short_name;
        let color = this.bin.color == null ? '': this.bin.color.name;
        let size = this.bin.size == null ? '': this.bin.size.name;
        return company + ' ' + color + ' ' + size + ' #' + this.bin.number;
      }
    },
    components:{
    }
  }
</script>
